import styled from 'styled-components';

export const StyledDropdownsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    gap: 30px;
    align-items: end;

    .bllink-button {
        width: 300px
    }

    .comment {
        grid-column-start: 2
    }
`

export const StyledButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 70px;
    .green {
        background: #0CD977;
        width: 300px
    }
`